export enum EDegreeTypes {
  NOT_APPLICABLE = 'N/A',
  DOCTORATE = 'Doctorate',
  MASTERS = 'Masters',
  BACHELORS = 'Bachelors'
}
